import { ChangeEvent, FC, KeyboardEvent } from 'react';
import Button from '../../../../ui/button/button';
import Input from '../../../../common/input/input';
import { BUTTON_VARIANTS } from '../../../../constants/button-variants';
import translation from '../../../../languages';
import VoucherErrors from './voucher-errors';

export type VoucherPropsType = TranslationProps & {
    cart: Cart;
    voucherCode: string;
    attachVoucher: () => void;
    handleVoucher: (e: ChangeEvent<HTMLInputElement>) => void;
    handleVoucherInputKeyPress: (e: KeyboardEvent<HTMLInputElement>) => void;
};

const Voucher: FC<VoucherPropsType> = (props) => {
    const { cart, voucherCode, attachVoucher, handleVoucher, handleVoucherInputKeyPress, t } = props;
    const isAppliedPromo = cart?.promo?.applied;
    const isAppliedPromoVoucher = isAppliedPromo && cart?.voucher?.code;

    return (
        <div>
            {(isAppliedPromoVoucher || !cart.voucher) && (
                <div className='voucher-info mt-24'>
                    <div className='input-group voucher-group d-flex justify-content-between align-items-center'>
                        <div className='voucher-input'>
                            <Input
                                className='form-control'
                                placeholder={t('cart.cartSummary.enterTheCode')}
                                type='text'
                                value={voucherCode}
                                onChange={handleVoucher}
                                onKeyPress={(e) => handleVoucherInputKeyPress(e)}
                            />
                        </div>
                        <Button
                            className='styled voucher-btn'
                            onClick={() => attachVoucher()}
                            variant={BUTTON_VARIANTS.SECONDARY}
                        >
                            {t('cart.cartSummary.apply')}
                        </Button>
                    </div>
                </div>
            )}
            <VoucherErrors voucherError={cart.voucherError} />
        </div>
    );
};

const translate = translation('cart');

export default translate(Voucher);
